// merchantSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { checkMerchantOrBCAPI } from '../utils/API/Merchant APIs/MerchantApiCalls';

export const checkIsMerchantOrBcGlobal = createAsyncThunk('merchant/checkIsMerchantOrBc', async (_, { rejectWithValue }) => {
    try {
        const agentid = localStorage.getItem('id');
        const payload = { agentid };
        const response = await checkMerchantOrBCAPI(payload);
        if (response?.status === 200) {
            const eSignStatus = response?.data?.isESigned;
            const agentType = response?.data?.agentType;
            const pendingStatus = response?.data?.isPending;

            // Update localStorage
            if (pendingStatus) {
                localStorage.setItem('isNormalMerchant', 'pending');
            } else if (agentType !== 'Merchant') {
                localStorage.setItem('isNormalMerchant', 'false');
            } else {
                localStorage.setItem('isNormalMerchant', 'true');
            }
            return { eSignStatus, agentType, pendingStatus };
        }
    } catch (error) {
        return rejectWithValue(error.response?.data || 'Something went wrong');
    }
});

const merchantSlice = createSlice({
    name: 'merchant',
    initialState: {
        loading: false,
        eSignStatus: null,
        agentType: null,
        error: null,
        pendingStatus: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(checkIsMerchantOrBcGlobal.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(checkIsMerchantOrBcGlobal.fulfilled, (state, action) => {
                state.loading = false;
                state.eSignStatus = action.payload.eSignStatus;
                state.agentType = action.payload.agentType;
                state.pendingStatus = action.payload.pendingStatus;
            })
            .addCase(checkIsMerchantOrBcGlobal.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default merchantSlice.reducer;
